import Insights from "../../../../components/AssetManagement/Overview/Insights/Insights";

const InsightsScreen = () => {
  return (
    <>
      <Insights />
    </>
  );
};

export default InsightsScreen;
